/* eslint-disable eqeqeq */
import { FormRow } from 'framework/ui/layout';
import { PositionDropdown, SOFTWARE_ENGINEER_ID } from 'domain/shared/employee';
import { TechnologyDropdown } from 'domain/shared/career';
import {
  NumberInput,
  TextInput,
  EnumDropdown,
  useInputHelper,
  InputListTemplateProps,
  FormFieldsData,
} from 'framework/form';
import { PROJECT_MEMBERSHIP_ROLES } from 'domain/shared/core/constants';
import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';
import { get } from 'lodash';

const TeamPositionsWithQualificationForm = ({ isOldStructure, isUpdate, ...props }: InputListTemplateProps) => {
  const { getSource } = useInputHelper(props);
  const source = getSource();

  const { ACCOUNT_MANAGER, ...projectRolesForDropdown } = PROJECT_MEMBERSHIP_ROLES;

  const isDisabled = (data: FormFieldsData) => get(data, `${source}._isExistingSOWReplacementPosition`) || isUpdate;

  return (
    <FormRow colMd={4} colXl={3}>
      <PositionDropdown
        disabled={isDisabled}
        source={`${source}.positionId`}
        label="Position"
        onPositionChange={value => {
          if (!value || value != SOFTWARE_ENGINEER_ID.toString()) {
            return {
              [`${source}.technologyId`]: null,
            };
          }
          return {};
        }}
      />
      <EnumDropdown
        disabled={isDisabled}
        options={projectRolesForDropdown}
        source={`${source}.requiredRole`}
        label="Project role"
      />
      <FormRow colMd={isOldStructure ? 4 : 6} colXl={isOldStructure ? 4 : 6}>
        <TextInput source={`${source}.qualification`} label="Qualification" disabled isVisible={isOldStructure} />
        <EnumDropdown options={EMPLOYEE_COMPETENCY_LEVEL} source={`${source}.competencyLevel`} label="Level" />
        <NumberInput source={`${source}.requiredFte`} label="FTE" />
      </FormRow>
      <FormRow colMd={12} colXl={12}>
        <TechnologyDropdown
          disabled={isDisabled}
          source={`${source}.technologyId`}
          label="Technology"
          isVisible={data => get(data, `${source}.positionId`) == SOFTWARE_ENGINEER_ID}
        />
      </FormRow>
    </FormRow>
  );
};

export default TeamPositionsWithQualificationForm;
